import React from "react";

const PasswordInput = ({
  name,
  id = "", // Default parameter
  label,
  ariaLabel = "",
  value,
  handleChange,
  placeholder = "", // Default parameter
  required = false, // Default parameter
  errorMessage = {}, // Default parameter
  showPassword,
  disabled = false, // Default parameter
  togglePasswordVisibility,
  maxlength,
  handleBlur,
  onKeyDown,
  autoComplete = "off",
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) => {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof placeholder === "string" && placeholder.trim() ? placeholder.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Password";

  return (
    <>
      {label && (
        <label
          htmlFor={id || name}
          className="form-label col-form-label w-100 fs-5 form-label-custom-visible p-0"
        >
          {label} {isRequired && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="position-relative">
        <input
          name={name}
          id={id || name}
          type={showPassword ? "text" : "password"} // Keep password visibility toggle logic
          className={`form-control mb-5px fs-5 fw-normal pe-5${
            errorMessage[name]?.trim()?.length > 0 ? " input-error" : ""
          }`}
          value={value}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
          disabled={disabled}
          maxLength={maxlength}
          onBlur={handleBlur}
          autoComplete={autoComplete}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault(); // 🚫 block space
            }
            if (onKeyDown) {
              onKeyDown(e); // still allow other custom handlers
            }
          }}
          style={{ paddingRight: "2.5rem" }}
          aria-label={ariaLabelText}
          aria-required={isRequired}
          aria-invalid={Boolean(errorMessage?.[name])}
          aria-describedby={errorMessage?.[name] ? `${id || name}-error` : undefined}
        />
        <button
          type="button"
          className="btn btn-light position-absolute end-0 top-50 translate-middle-y p-0 border-0 bg-white me-2"
          onClick={togglePasswordVisibility}
          aria-label={showPassword ? "Hide password" : "Show password"}
          aria-pressed={showPassword}
          style={{ zIndex: 10 }}
          disabled={disabled}
        >
          <i
            className={`fas ${
              showPassword ? "fa-eye-slash" : "fa-eye"
            } text-dark`}
          ></i>
        </button>
      </div>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div id={`${id || name}-error`} role="alert" className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </>
  );
};

export default PasswordInput;
